import * as React from 'react';

interface DeleteWarningListProps {
  items: string[];
}

export const DeleteWarningList: React.FC<DeleteWarningListProps> = ({ items }) => (
  <ul className='mb-8 space-y-3'>
    {items.map((item, index) => (
      <li key={index} className='flex items-start gap-3'>
        <span className='mt-1.5 size-1.5 shrink-0 rounded-full bg-red-500' />
        <span className='font-sans text-16 font-normal leading-24 text-brand-800'>{item}</span>
      </li>
    ))}
  </ul>
);
